import React, { useContext } from 'react';
import Stars from 'atomic/stars';
import Link from 'atomic/link';
import opiBadge from 'assets/images/badge/opineo_badge.webp';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { useSeo } from 'hooks/use-seo';
import StarsRating from 'atomic/stars-rating';
import { generateAddOpinionLink } from 'helpers/url-manager';

import './product-opinion-summary.scss';

interface OpinionSummaryProps {
    title: string;
    url: string;
    count: number;
    average: number;
    ratings: number[];
}

const ProductOpinionSummary: React.FC<OpinionSummaryProps> = ({ title, url, count, average, ratings }) => {
    const seo = useSeo();
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const calculateStarPercentage = (singleRating: number, total: number): number => {
        if (total > 0) {
            return singleRating / (total / 100.0);
        }

        return 0;
    };

    return (
        <div className="opinion-summary">
            <div className="opinion-summary__rating-container">
                <div className="opinion-summary__rating-container--mobile">
                    <div className="opinion-summary__rating-container__average">
                        {average.toFixed(1)}
                        <span>
                            / 5
                        </span>
                    </div>
                    <Stars width={average} inline={true} size="lg" />
                </div>
                <Link
                    className="opinion-summary__rating-container__badge"
                    href={url ? url : 'https://www.opineo.pl/'}
                    rel="noopener noreferrer"
                    ariaLabel={title}
                    target="_blank"
                    title={title}
                >
                    <img
                        src={opiBadge}
                        width={112}
                        height={66}
                        alt={title}
                        loading="lazy"
                    />
                </Link>
            </div>
            <ul className="opinion-summary__stars-container">
                {
                    ratings?.map((singleRating, index) => (
                        <StarsRating
                            key={index}
                            percentage={calculateStarPercentage(singleRating, count)}
                            index={index + 1}
                        />
                    ))
                }
            </ul>
            <div className="opinion-summary__product-container">
                <div className="opinion-summary__product-container__header">
                    Masz ten produkt?
                </div>
                <div className="opinion-summary__product-container__product">
                    Oceń {seo.h1} i pomóż innym w wyborze.
                </div>
                { url && (
                    <Link
                        href={generateAddOpinionLink(url)}
                        type="button"
                        className="opinion-summary__product-container__button"
                        color="transparent"
                        size="lg"
                        target="_blank"
                        rel={`noopener noreferrer ${count === 0 ? 'nofollow' : ''}`}
                    >
                        Napisz opinię
                    </Link>
                )}

            </div>
        </div>
    );
};

export default ProductOpinionSummary;
